import { render, staticRenderFns } from "./ReturnStep.vue?vue&type=template&id=2c65edd8&scoped=true&"
import script from "./ReturnStep.vue?vue&type=script&lang=ts&"
export * from "./ReturnStep.vue?vue&type=script&lang=ts&"
import style0 from "./ReturnStep.vue?vue&type=style&index=0&id=2c65edd8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c65edd8",
  null
  
)

export default component.exports